module.exports = __webpack_public_path__ + "static/media/clarity-lang.1d85d171.png";